<template>
  <div class="c-block-list">
    <h3 class="c-block-list__title" v-if="title">{{ title }}</h3>
    <div class="c-block-list__actions" v-if="!!$slots.actions">
      <slot name="actions" />
    </div>
    <div
      class="c-block-list__items"
      :class="{
        'c-block-list__items--shadow': shadow,
        'c-block-list__items--no-padding': !padding
      }"
    >
      <slot />
    </div>
  </div>
</template>

<script>
// @group Base Components
export default {
  name: 'OBlockList',
  props: {
    title: {
      type: String,
      default: null
    },
    shadow: {
      type: Boolean,
      default: true
    },
    padding: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss">
.c-block-list {
  position: relative;
}

.c-block-list__title {
  display: block;
  font-size: 1.4rem;
  font-weight: 600;
  padding: 2rem 1.6rem;
}

.c-block-list__actions {
  color: $primary-color;
  color: var(--primary-color);
  position: absolute;
  right: 1.6rem;
  top: 1.6rem;
}

.c-block-list__items {
  background: #fff;
  padding: 0.8rem 0;
}

.c-block-list__items--no-padding {
  padding: 0;
}

.c-block-list__items--shadow {
  box-shadow: $box-shadow-list;
}

.c-block-list + .c-block-list {
  margin-top: 1.6rem;
}
</style>
